import { useState, useRef } from 'react';
import { ColorPicker } from 'antd';
import HStack from '../common/Layout/HStack';
import VStack from '../common/Layout/VStack';
import AppText from './AppText';
import { GlobalStyleAttributes } from '../../styles/GlobalStyles';
import { Colors } from '../../styles/Colors';
import { t } from 'i18next';
import SimpleInput from './SimpleInput';

const formatToLabel = (format) => {
    switch (format) {
        case 'rgb': return 'RGBA';
        case 'hsb': return 'HSB';
        default: return 'HEX#';
    }
};

const serializeColor = (color, format) => {
    switch (format) {
        case 'rgb': return color.toRgbString();
        case 'hsb': return color.toHsbString();
        default: return color.toHexString();
    }
};

const BrandedColorRow = ({fieldKey, value, setFieldValue, initialFormat, label}) => {
    const alphaEnabled = initialFormat === 'rgba';
    const [format, setFormat] = useState(alphaEnabled ? 'rgb' : initialFormat);
    const formatRef = useRef(format);
    const colorRef = useRef(null);
    formatRef.current = format;

    const onColorChange = (color) => {
        colorRef.current = color;
        setFieldValue(fieldKey, serializeColor(color, formatRef.current));
    };

    const onFormatChange = (newFormat) => {
        formatRef.current = newFormat;
        setFormat(newFormat);
        if (colorRef.current) {
            setFieldValue(fieldKey, serializeColor(colorRef.current, newFormat));
        }
    };

    const currentLabel = formatToLabel(format);

    return (
        <VStack space={'0.25rem'}>
            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t(label)}</AppText>
            <HStack alignItems={'center'} space={'0.5rem'} width={'100%'}>
                <ColorPicker
                    value={value}
                    format={format}
                    disabledAlpha={!alphaEnabled}
                    onFormatChange={onFormatChange}
                    onChange={onColorChange}
                >
                    <div style={{
                        width: 43,
                        height: 43,
                        borderRadius: '50%',
                        backgroundColor: value || '#ffffff',
                        cursor: 'pointer',
                        flexShrink: 0,
                        border: `1px solid ${Colors.newDesign.mediumGrey}`,
                    }}/>
                </ColorPicker>
                <HStack
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    flex={1}
                    height={'40px'}
                    px={'11px'}
                    style={{
                        border: '1px solid',
                        borderColor: Colors.newDesign.mediumGrey,
                        borderRadius: '6px',
                    }}
                >
                    <span style={{color: Colors.newDesign.darkerGrey, fontSize: '14px'}}>{currentLabel}</span>
                    <SimpleInput 
                        inputType='text'       
                        value={value || ''}
                        placeholder={currentLabel}
                        onChangeCallback={(val) => setFieldValue(fieldKey, val)}
                        style={{
                            border: 'none',
                            textAlign: 'end',
                        }}
                    />
                </HStack>
            </HStack>
        </VStack>
    );
};

export default BrandedColorRow;